import { parse } from 'qs';

export const getQueryStringParam = (name: string) => {
  const parsedQueryString = parse(window.location.search, { ignoreQueryPrefix: true });

  return parsedQueryString[name];
};
